module.exports = __webpack_public_path__ + "static/media/DINNextRoundedLTPro-Bold.1e714b48.otf";